import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from './pages/Home';          
import About from './pages/About';
import Shop from './pages/Shop';
import Cart from './pages/Cart';
import Track from './pages/Track';
import Card from './pages/Card';
import Wallet from './pages/Wallet';
import Stand from './pages/Stand';
import Powerbank from './pages/Powerbank';
import Utility from './pages/Utility';
import Hunting from './pages/Hunting';
import Knife from './pages/Knife';
import Chapstick from './pages/Chapstick';
import Bottle from './pages/Bottle';
import MetalPencil from './pages/MetalPencil';
import Privacy from './pages/Privacy';
import Tnc from './pages/Tnc';
import Refunds from './pages/Refunds';
import Success from './pages/Success';
import Cancelled from './pages/Cancelled';
import { CartProvider } from './context/CartContext';


function App() { 
  return (
    <CartProvider>

    <Router>
      <Routes>
        <Route path="/" element={<Home />} /> //Screen Adaptible!
        <Route path="/shop" element={<Shop />} /> //Screen Adaptible! 
        <Route path="/cart" element={<Cart />} /> //Screen Adaptible!
        <Route path="/track" element={<Track />} />  //Screen Adaptible!
        <Route path="/card" element={<Card />} /> //Screen Adaptible!
        <Route path="/wallet" element={<Wallet />} /> //Screen Adaptible!
        <Route path="/stand" element={<Stand />} /> //Screen Adaptible!
        <Route path="/powerbank" element={<Powerbank />} /> //Screen Adaptible!
        <Route path="/utility" element={<Utility />} /> //Screen Adaptible!
        <Route path="/hunting" element={<Hunting />} /> //Screen Adaptible!
        <Route path="/knife" element={<Knife />} /> //Screen Adaptible!
        <Route path="/chapstick" element={<Chapstick />} /> //Screen Adaptible!
        <Route path="/bottle" element={<Bottle />} /> //Screen Adaptible!
        <Route path="/metalpencil" element={<MetalPencil />} /> //Screen Adaptible!
        <Route path="/about" element={<About />} /> //Screen Adaptible!
        <Route path="/privacy" element={<Privacy />} /> //Screen Adaptible!
        <Route path="/tnc" element={<Tnc />} />  //Screen Adaptible!
        <Route path="/exchange&delivery" element={<Refunds />} /> //Screen Adaptible!
        <Route path="/success" element={<Success />} /> //Screen Adaptible!
        <Route path="/cancel" element={<Cancelled />} />  //Screen Adaptible!
      </Routes>
    </Router>
    </CartProvider>

  );
}

export default App;
